import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-bootstrap'

import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import pitch from '@assets/images/icon/stadium-icon.svg'
// import weather from '@assets/images/icon/Cloud.svg'
// import clearSky from '@assets/images/icon/clearSky.svg'
// import smoke from '@assets/images/icon/smoke.svg'
// import fewClouds from '@assets/images/icon/fewClouds.svg'
// import scatteredClouds from '@assets/images/icon/scatteredClouds.svg'
// import scatteredClouds from '@assets/images/icon/scatteredClouds.svg'
import brokenClouds from '@assets/images/icon/infoWeather/brokenClouds.svg'
import smoke from '@assets/images/icon/infoWeather/smoke.svg'
import clearSky from '@assets/images/icon/infoWeather/clearSky.svg'
import fewClouds from '@assets/images/icon/infoWeather/fewClouds.svg'
import scatteredClouds from '@assets/images/icon/infoWeather/scatteredClouds.svg'
import thunderstormWithRain from '@assets/images/icon/infoWeather/thunderstorm_with_rain.svg'
import haze from '@assets/images/icon/infoWeather/haze.svg'
import overcastClouds from '@assets/images/icon/infoWeather/overcastClouds.svg'
import lightRain from '@assets/images/icon/infoWeather/lightRain.svg'
import mist from '@assets/images/icon/infoWeather/mist.svg'
import fog from '@assets/images/icon/infoWeather/fog.svg'
import moderateRain from '@assets/images/icon/infoWeather/moderateRain.svg'
import lightSnow from '@assets/images/icon/infoWeather/lightSnow.svg'
import heavyRain from '@assets/images/icon/infoWeather/heavyRain.svg'

import temp from '@assets/images/icon/temp.svg'
import avg from '@assets/images/icon/average-icon.svg'

const MyImage = dynamic(() => import('@shared/components/myImage'))

const InfoList = ({ fantasystyles, overViewData, overviewWeather, overviewPitch }) => {
  function getImage(desc) {
    const Images = {
      'broken clouds': brokenClouds,
      smoke: smoke,
      'clear sky': clearSky,
      'few clouds': fewClouds,
      'scattered clouds': scatteredClouds,
      'thunderstorm with rain': thunderstormWithRain,
      haze: haze,
      'overcast clouds': overcastClouds,
      'light rain': lightRain,
      mist: mist,
      fog: fog,
      'moderate rain': moderateRain,
      'light snow': lightSnow,
      'heavy rain': heavyRain
    }
    return Images[desc?.toLowerCase()] || ''
  }

  return (
    <Row className={`${styles.list} row-8 mb-3 mb-md-1 mt-3`}>
      <Col sm={6} xxl={3} md={3} xs={6}>
        <div className={`${styles.item} ${styles.mb_sm}  common-box d-flex`}>
          <div className={`${styles.icon} me-3`}>
            <MyImage src={temp} alt="Prediction" layout="responsive" />
          </div>
          <div className="ms-2 ms-md-0 mt-md-0 mt-2">
            <div className={`${styles.value} fw-bold`}>{overviewWeather?.sTemperature ? `${overviewWeather?.sTemperature}° C` : '-'}</div>
            <p className={`${fantasystyles?.itemSubTitle} ${styles.itemTitle} text-muted mb-0`}>
              <span>Temperature</span>
            </p>
          </div>
        </div>
      </Col>
      {/* {overViewData?.sWeatherReport && ( */}
      <Col sm={6} xxl={3} md={3} xs={6}>
        <div className={`${styles.item} ${styles.mb_sm} common-box d-flex `}>
          <div className={`${styles.icon} me-3`}>
            <MyImage src={getImage(overviewWeather?.sWeatherDescription || 'clear sky')} alt="weather" layout="responsive" />
          </div>
          <div className="ms-2 ms-md-0 mt-md-0 mt-2">
            <div className={`${styles.value} fw-bold`}>
              {overviewWeather?.sWeatherDescription ? overviewWeather?.sWeatherDescription : '-'}
            </div>
            <p className={`${fantasystyles?.itemSubTitle} ${styles.itemTitle} text-muted mb-0`}>
              <span>{'Weather Report'}</span>
            </p>
          </div>
        </div>
      </Col>
      {/* )} */}
      {/* {overViewData?.sPitchCondition && ( */}
      <Col sm={6} xxl={3} md={3} xs={6}>
        <div id="pitch" className={`${styles.item} ${styles.mb_sm}  common-box d-flex`}>
          <div className={`${styles.icon} me-3`}>
            <MyImage src={pitch} alt="pitch" layout="responsive" />
          </div>
          <div className="ms-2 ms-md-0 mt-md-0 mt-2">
            <div className={`${styles.value} fw-bold`}>{overviewPitch?.sPitchCondition ? overviewPitch?.sPitchCondition : '-'}</div>
            <p className={`${fantasystyles?.itemSubTitle} ${styles.itemTitle} text-muted mb-0`}>
              <span>{'Pitch Condition'}</span>
            </p>
          </div>
        </div>
      </Col>
      {/* )} */}
      {/* {overViewData?.sAvgScore && ( */}
      <Col sm={6} xxl={3} md={3} xs={6}>
        <div className={`${styles.item} ${styles.mb_sm}  common-box d-flex`}>
          <div className={`${styles.icon} me-3`}>
            <MyImage src={avg} alt="Score" layout="responsive" />
          </div>
          <div className="ms-2 ms-md-0 mt-md-0 mt-2">
            <div className={`${styles.value} fw-bold`}>{overviewPitch?.sBattingCondition ? overviewPitch?.sBattingCondition : '-'}</div>
            <p className={`${fantasystyles?.itemSubTitle} text-muted mb-0`}>
              {/* <span>{"Avg 1st Inn Score"}</span> */}
              <span>Batting Condition</span>
            </p>
          </div>
        </div>
      </Col>
      {/* )} */}
    </Row>
  )
}

InfoList.propTypes = {
  fantasystyles: PropTypes.any,
  overViewData: PropTypes.object,
  overviewWeather: PropTypes.object,
  overviewPitch: PropTypes.object
}

export default InfoList
